export default __webpack_public_path__ + "static/media/Junge-schläft.3a3acd6d.png";